import { render } from "./page-parents.vue?vue&type=template&id=bae8c3c4"
import script from "./page-parents.vue?vue&type=script&lang=js"
export * from "./page-parents.vue?vue&type=script&lang=js"
script.render = render

export default script